export const updateUserBase = `mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
  updateUser(input: $input, condition: $condition) {
    id
    firstName
    lastName
    phoneNumber
    email
    avatar
    title
    company
    createdAt
    updatedAt
  }
}
`

export const registerUser = /* GraphQL */ `
  mutation RegisterUser($input: CreateUserInput!, $condition: ModelUserConditionInput) {
    createUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      avatar
      company
      title
      country
      createdAt
      updatedAt
    }
  }
`
